import { SubscriptionTier } from "@/client"

export const ERROR_MESSAGE_DEFAULT =
  'Something went wrong. Please try again later, our engineers are on top of it, but pinging us on instagram/email will help.'

export const PLACEHOLDER_AVATAR = 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.6&w=256&h=256&q=80'

export enum Pricing {
  StarterMonthly = 79,
  BasicMonthly = 139,
  ProMonthly = 249,
  StarterAnnually = 63,
  BasicAnnually = 111,
  ProAnnually = 199,
}

export const subscriptionLimits = {
  [SubscriptionTier.NONE]: 0,
  [SubscriptionTier.STARTER]: 6,
  [SubscriptionTier.BASIC]: 12,
  [SubscriptionTier.PRO]: 24,
}